// extracted by mini-css-extract-plugin
module.exports = {"section":"FormSection_section__06w8V","subText":"FormSection_subText__zKbZO","titleContainer":"FormSection_titleContainer__txHAo"};